import React from 'react';
import CandidateHero from '../components/CandidateHero';
import CandidateCareer from '../components/CandidateCareer';
import CandidateWhyChooseNew from '../components/CandidateWhyChooseNew';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import CallToAction from '../components/CallToAction';
import Footer from '../components/Footer';
import FadeInSection from '../components/FadeInSection';

const Candidates: React.FC = () => {
    return (
        <>
            <CandidateHero />

            <FadeInSection delay={0.2}>
                <CandidateCareer />
            </FadeInSection>

            <FadeInSection delay={0.2}>
                <CandidateWhyChooseNew />
            </FadeInSection>

            <FadeInSection delay={0.2}>
                <Testimonials />
            </FadeInSection>

            <FadeInSection delay={0.2}>
                <FAQ
                    candidateFaqs={[
                        { q: "I am not currently looking for a new role, should I still sign up?", a: "Yes! Our goal is to help you proactively find your dream role, don't wait for something negative to happen to start thinking about what's next." },
                        { q: "How does the matching system work?", a: "David, our AI recruiter, learns from you. When you sign up, you share your career goals and preferences, and he uses that information to create a tailored search. As you review roles and provide feedback, David continuously refines his recommendations—bringing you closer to the opportunities that truly match your ambitions." },
                        { q: "What if I want to switch industries, or change career paths?", a: "That's exciting—and we're here to support you. David will highlight your transferable skills and position your background in the best light when introducing you to companies. Our goal is to surface roles that align with your ambitions, even if they take you in a new direction." },
                        { q: "How much does Hush cost?", a: "Hush is completely free for candidates. In fact, we'll give you a $500 bonus when you land your next role through us, plus another $500 for every person you refer who finds their next role with Hush." },
                        { q: "Who can see my profile?", a: "You're in full control. Your profile is never shared without your explicit permission. You can also create a personal \"blacklist\" of companies you're not interested in - and your current employer is automatically added to that list to protect your privacy." }
                    ]}
                    employerFaqs={[]}
                />
            </FadeInSection>

            <FadeInSection delay={0.2}>
                <CallToAction />
            </FadeInSection>

            <Footer />
        </>
    );
};

export default Candidates;
